function Error() {
  return (
    <div className="container">
      <h2 className="title">
        Oh no! something went wrong <span>😭</span>
      </h2>
    </div>
  )
}

export default Error
